module.exports = __webpack_public_path__ + "media/images/icon__live-cdb787ebee41aa240a459ef4e7baa977.png";